import utils from './utils';
import './utils/ext';
// import './assets/css/components.less';
import Ajax from './utils/ajax';
import Storage from './utils/storage';
// import components from './components';
import setting from './setting';
export default (Vue, settings) => {
  setting.set(settings);
  Vue.use(utils);
  // Vue.use(components);
  Vue.use(Ajax);
  Vue.use(Storage);
};



// WEBPACK FOOTER //
// ./src/framework/index.js